import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { useCustomToast } from 'hooks';
import { updateDefaultCustomFilter } from 'modules/_common/api';

export const useMutationUpdateDefaultCustomFilter = () => {
  const { t } = useTranslation();

  const { successToast, errorToast } = useCustomToast();

  const queryClient = useQueryClient();

  return useMutation(updateDefaultCustomFilter, {
    onSuccess: () => {
      queryClient.refetchQueries(QUERY_KEYS.RESERVATION_NEW_CUSTOM_FILTER);
      queryClient.refetchQueries(QUERY_KEYS.RENTALS_PROPERTIES);
      queryClient.refetchQueries(QUERY_KEYS.EVISITOR_GUESTS);
      successToast(t('You have successfully set the filter as defaul'));
    },
    onError: () => errorToast(),
  });
};
